import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { uniqueId } from 'lodash';

import { CopyBase } from '../copy-base';
import { CopyService } from '../copy-service/copy.service';

/**
 * Block Copy component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { BlockCopyModule } from 'patternfly-ng/copy';
 * // Or
 * import { BlockCopyModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [BlockCopyModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { CopyEvent } from 'patternfly-ng/copy';
 * </pre></code>
 */

export class BlockCopyComponent extends CopyBase implements OnInit {
  /**
   * Label output above the block copy component
   */
   label: string;

  /**
   * Copy button label
   */
   buttonLabel: string;

  /**
   * Flag indicating the expanded state for the expansion panel
   */
   expanded: boolean = false;

  /**
   * Aria label for the expansion toggle
   */
   expandToggleAriaLabel: string;

  /**
   * Generates a unique prefix for element IDs
   */
  protected uniqueID: string = uniqueId('pfng-block-copy');

  /**
   * The default constructor
   */
  constructor(protected copyService: CopyService) {
    super(copyService);
  }

  ngOnInit() {
    if (!this.buttonAriaLabel && this.buttonLabel) {
      this.buttonAriaLabel = this.buttonLabel;
    }
  }

  /**
   * Generates a unique ID for the button
   */
  get buttonId(): string {
    return `${this.uniqueID}-button`;
  }

  /**
   * Toggle expansion panel open and close
   */
  togglePanel(): void {
    this.expanded = !this.expanded;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-block-copy',
  template: `<div class="pfng-block-copy" [ngStyle]="{'width': width}"><label *ngIf="label" class="pfng-block-copy-label" [attr.for]="buttonId">{{label}}</label><div class="pfng-block-copy-inner-container"><div class="pfng-block-copy-preview" [ngClass]="{'pf-is-open': expanded}"><button type="button" [attr.aria-label]="expandToggleAriaLabel" [attr.aria-expanded]="expanded" class="btn btn-default pfng-block-copy-preview-btn" (click)="togglePanel()"><i aria-hidden="true" class="fa pfng-block-copy-preview-icon" [ngClass]="{'fa-angle-down': expanded, 'fa-angle-right': !expanded}"></i></button><div class="pfng-block-copy-preview-txt-cont" [placement]="tooltipPlacement" [tooltip]="tooltipText" container="body"><input type="text" tabindex="-1" [value]="value" class="pfng-block-copy-preview-txt" readonly="readonly"></div><button type="button" [attr.id]="buttonId" class="btn btn-default pfng-block-copy-btn" [attr.aria-label]="buttonAriaLabel" [tooltip]="copyBtnTooltipText" [placement]="copyBtnTooltipPlacement" triggers="hover" container="body" (click)="copy()"><span><ng-container *ngIf="!recentlyCopied"><i class="fa fa-clipboard" aria-hidden="true"></i></ng-container><ng-container *ngIf="recentlyCopied"><i class="fa fa-check" aria-hidden="true"></i></ng-container></span></button></div><div class="pfng-block-copy-body" *ngIf="expanded"><span>{{value}}</span></div></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CopyService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input, args: ['label', ] },],
'buttonLabel': [{ type: Input, args: ['buttonLabel', ] },],
'expanded': [{ type: Input, args: ['expanded', ] },],
'expandToggleAriaLabel': [{ type: Input, args: ['expandToggleAriaLabel', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
